module.exports = __webpack_public_path__ + "img/年会.2d6f8ec4.jpg";